<template>
<Modal 
    :id="'cmp_bookings_booking_add_artist'"
    @cancelled="onCancelClick"  
>
    <template slot="header">
        <template v-if="isLoading"> {{$t('attention')}}</template>
        
    </template>
    <template slot="body">
        <div class="ut-fc" style="height:100px">
            <NTable
                class="dbox1"
                id="catalog-releases-sidewindow-licences"
                :config="tableConfig"
                :headers="headers"
                :items="productList"
                :showNoItems="true"
            >
                <template v-slot:item="{ item, tdcon }">
                    <tr>
                    <td v-bind="tdcon('catalog_no')">
                        <span>{{ item["column1"] }}</span>
                    </td>
                    <td v-bind="tdcon('format')">
                        <span>{{ item["column2"] }}</span
                        >
                    </td>
                    </tr>
                </template>
            </NTable>
        </div>

        <div  style="text-align:center">
          <p style="font-weight:800"> {{$t('delete_supplier_order_msg')}}  </p>
        </div>

     </template>
    <template slot="options">
      
        <button  class="dt-button s7" @click="onCancelClick">{{$t('cancel')}}</button>
        <button class="dt-button s7 v1" @click="onOKClicked">{{$t('ok')}}</button>
    </template>
</Modal>
  
  
</template>

<script>
import Modal from '../../../../dt-plugins/modal/modal';

import { DTIconButton } from "../../../../plugins/button/button";
import NTable from "../../../../plugins/datatable/datatable";

import InputField from "@plugins/text-field/input-field";


import ModalContainer from "@dtplugins/modal/modal-container";


import { createNTableConfig, createTableHeader } from "../../../../plugins/datatable";




export default {
  props: {
    productList: {
      type: Array,
      default:[]
    }
  },
  components: {
    
    Modal,
    NTable,
    InputField,
    DTIconButton,
    ModalContainer,

   
    //AdvanceSearch,
   
  },
  mounted:async  function () {
    //DistributionStatementService
  },
  data: function () {
    return {
        isLoading:true,
        tableConfig: createNTableConfig({
            headerStyle: 3,
            fullHeight: true
        }),
    
    };
  },
   mixins: [],

  computed: {
     headers: function () {
      return [
        createTableHeader("catalog_no",{ }),
        createTableHeader("format",{ text:false}),
      ];
    },
    
  },
  methods: { 
    onCancelClick: function() {
      this.$emit("cancelled", true);
    },
    onOKClicked:function(){
        console.log(this.$route.query.supplier_order_id);

        const supplier_order_id = this.$route.query.supplier_order_id

        this.$emit("onDelete",supplier_order_id)
    }
    
  
  },
};
</script>

<style lang="scss">
.cmp-catalog-releases-releases_list {
  .dt-page--body {
    --offset: 190px;
  }
  td.file_name a {
  }
  .dt-page--data-table {
    --offset: 135px;
  }
  .dt-page--top-bar {
    .input-field-container {
      max-width: 128px;
    }
  }
  //   .invoicelist-footer {
  //   border-top: 1px solid var(--sprt-5);

  //   .invoice_status_list {
  //     display: flex;
  //     .status {
  //       margin-top: 15px;
  //       display: flex;
  //       // max-width: 150px;
  //       flex: 0.5;
  //       .circle {
  //         width: 15px;
  //         height: 15px;
     
  //         margin-right: 10px;
  //         margin-top: 2.5px;
  //       }
  //       .status-name {
  //         flex: 1;
  //       }
  //     }
  //   }
  // }
}
</style>